// Copyright (c) 2016 Deere & Company

import Modal, {getDefaultState as getModalDefaultState} from '../../shared/state/modal';

const DealerSearchModal = Modal;

export const getDefaultState = () => getModalDefaultState();

export default DealerSearchModal;



// WEBPACK FOOTER //
// ./src/product/new-transfer/state/dealer-search-modal.js